/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Exceptions_DescInputs */



/**
* | output |
* | --- |
* | "Switch Wundo or the notetaker off for a person or a recurring meeting." |
*
* @param {Meetings_Exceptions_DescInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_exceptions_desc = /** @type {((inputs?: Meetings_Exceptions_DescInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Exceptions_DescInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Hier zet je Wundo of de notetaker uit voor een persoon of een terugkerend gesprek.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ici, vous désactivez Wundo ou le notetaker pour une personne ou une conversation récurrente.")
	return /** @type {LocalizedString} */ ("Switch Wundo or the notetaker off for a person or a recurring meeting.")
});